import * as tslib_1 from "tslib";
import { UserApi } from '../api/user-api';
import * as i0 from "@angular/core";
import * as i1 from "../api/user-api";
var UserService = /** @class */ (function () {
    function UserService(userApi) {
        this.userApi = userApi;
    }
    UserService.prototype.verifyAccount = function (emailAddress) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryArgs, users;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryArgs = "email:\"" + emailAddress + "\"";
                        return [4 /*yield*/, this.userApi.queryUsers(queryArgs)];
                    case 1:
                        users = _a.sent();
                        if (users && Array.isArray(users) && users.length > 0) {
                            return [2 /*return*/, users[0]];
                        }
                        else {
                            // TODO: retrieve pdauth user info and create new user
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.searchUsers = function (searchText, max, includeADGroups, publicData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var users;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userApi.searchUsers(searchText, max, publicData)];
                    case 1:
                        users = _a.sent();
                        if (includeADGroups) {
                            // TODO: include active directory users
                        }
                        return [2 /*return*/, users];
                }
            });
        });
    };
    UserService.prototype.registerUser = function (email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userApi.registerUser(email)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserService.ngInjectableDef = i0.defineInjectable({ factory: function UserService_Factory() { return new UserService(i0.inject(i1.UserApi)); }, token: UserService, providedIn: "root" });
    return UserService;
}());
export { UserService };
